import {captureException} from '@sentry/react';

import {isRouteErrorResponse, useRouteError} from 'react-router-dom';

import {TestIdProps, useOnMount} from 'shared/web';

import {ErrorPage} from './ErrorPage';

type RouteErrorPageProps = TestIdProps;

export function RouteErrorPage(props: RouteErrorPageProps) {
  const routeError = useRouteError();
  const isNotFound = isRouteErrorResponse(routeError) && routeError.status === 404;

  useOnMount(() => {
    if (isRouteErrorResponse(routeError)) {
      if (routeError.status >= 500) {
        captureException(new Error(`Route error ${routeError.status}: ${routeError.statusText}`));
      }
      // 404 and other expected HTTP responses — intentionally not reported
      return;
    }

    if (routeError instanceof Error) {
      captureException(routeError);
    }
  });

  return <ErrorPage {...props} isNotFound={isNotFound} />;
}
